import styled, { css } from "styled-components";
import { media, mediaMax, theme } from "@customer-tools-web/component-ui/lib";

export const SpecialistWrapper = styled.div`
  border: 1px solid #d8d8d8;
  padding: 24px 16px 16px 16px;
  color: #333f48;
`;

export const Title = styled.div`
  font-size: 18px;
  line-height: 22px;
  font-weight: 700;
`;

export const SubTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin-top: 8px;
`;

export const LinkText = styled.a`
  color: ${theme.blue};
  font-size: 16px;
  font-weight: 600;
  margin-top: 24px;
  line-height: 24px;
  cursor: pointer;
  display: inline-block;

  ${mediaMax.md`
    margin-top: 16px;
  `}
`;

export const DetailWrapper = styled.div<{ isFullInfo?: boolean }>`
  margin-top: 16px;

  span.title {
    display: flex;
    align-items: center;
    text-transform: capitalize;

    ${mediaMax.md`
      font-weight: 600;
      font-size: 18px;
      line-height: 22px;
      color: #333F48;
    `}
    i {
      color: #333f48;
      margin-right: 8px;
      font-weight: 500;
    }
  }

  .ant-table-thead {
    vertical-align: baseline;
  }

  .ant-table-thead > tr > th {
    background: #ffffff;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;

    ${({ isFullInfo }) =>
      isFullInfo &&
      css`
        font-size: 14px;
        line-height: 20px;
      `}
    color: #333f48;
  }

  /* remove hover effect */
  .ant-table-thead
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-thead
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: none;
  }

  .ant-table-tbody > tr > td {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #333f48;
  }

  /* remove border-bottom on last row on responsive */
  ${mediaMax.md`
    .ant-table-tbody tr:last-child td {
      border-bottom: none;
      padding: 12px 0 0 0;
    }
  `}

  .ant-table-thead th {
    padding: 0 0 16px 0;
  }

  .ant-table-tbody td {
    padding: 12px 0;
  }

  .ant-table-tbody tr:last-child td {
    border-bottom: none;
    padding: 12px 0 0 0;
  }

  /* remove top padding on first td (AREA & CONDO title) on responsive */
  ${mediaMax.md`
    .ant-table-tbody > tr:first-child > td {
        padding: 0 0 12px 0;
    }
  `}

  /* add margin top to condo table */
  .detail-table-condo {
    margin-top: ${({ isFullInfo }) => (isFullInfo ? "40px" : "32px")};
  }
`;
export const SummaryWrapper = styled.div``;
export const SummaryTitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333f48;
`;

export const SummaryDetail = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #333f48;
  margin-top: 4px;
`;

export const SummaryDatePeriod = styled.div`
  color: #697684;
`;

export const Status = styled.div<{ status?: number }>`
  /* suspended */
  ${(props) =>
    props.status === 3 &&
    css`
      color: #d43900;
    `}
`;

export const PremiumBalanceTitle = styled.div`
  display: flex;
`;
